import { render, staticRenderFns } from "./MedicationTreatment.vue?vue&type=template&id=69936a13"
import script from "./MedicationTreatment.js?vue&type=script&lang=js&external"
export * from "./MedicationTreatment.js?vue&type=script&lang=js&external"
import style0 from "./MedicationTreatment.vue?vue&type=style&index=0&id=69936a13&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports